import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React, { useContext, useEffect, useRef, useState } from 'react';
import Block from 'wfui-digital-core/es/Block';
import Button from 'wfui-digital-core/es/Button';
import useStrings from 'wfui-digital-core/es/useStrings';
import useBrand from 'wfui-digital-core/es/useBrand';
import { getClasses } from 'wfui-digital-core/es/lib';
import globals from '../../../../../lib/globals/globals';
import StickyFooterContext from '../../../context/StickyFooterContext';
import ProfileIcon from '../../../icons/profile/ProfileIcon';
import ChevronIcon from '../../../icons/chevron/ChevronIcon';
import stripMarkup from '../../../support/strip-markup';
import styles from './ProfileMenuItem.less';

var ProfileMenuItem = function ProfileMenuItem() {
  var clicked = useRef(false);
  var menuItemRef = useRef();

  var _useStrings = useStrings(),
      getString = _useStrings.getString;

  var brand = useBrand();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      menuOpenedFromClick = _useState2[0],
      setMenuOpenedFromClick = _useState2[1];

  var _useContext = useContext(StickyFooterContext),
      menuConfig = _useContext.menuConfig,
      secondaryMenu = _useContext.secondaryMenu,
      setSecondaryMenu = _useContext.setSecondaryMenu,
      setHeaderContent = _useContext.setHeaderContent,
      secondaryMenuId = _useContext.secondaryMenuId,
      setCurrentMenuItem = _useContext.setCurrentMenuItem;

  useEffect(function () {
    if (secondaryMenu) {
      setMenuOpenedFromClick(clicked.current);
    }
  }, [secondaryMenu]);
  var profileConfig = menuConfig.sections[1].sections[1];
  var welcomeMessage = 'BIZ' === globals().customerLOB || 'TPB' === brand.toUpperCase() || !globals().firstName ? getString('global.welcome') : globals().firstName;

  var onClick = function onClick() {
    setSecondaryMenu(profileConfig);
    setHeaderContent(profileConfig.label);
    setCurrentMenuItem(menuItemRef.current);
  };

  var onMouseDown = function onMouseDown() {
    clicked.current = true;
  };

  var onBlur = function onBlur() {
    if (!secondaryMenu) {
      clicked.current = false;
      setMenuOpenedFromClick(false);
    }
  };

  var registered = " ".concat(getString('global.registered.sign'), " ");
  var ariaLabel = stripMarkup("".concat(welcomeMessage, ". ").concat(profileConfig.description)).replace('&reg;', registered).replace('®', registered);
  var classNames = getClasses({
    styles: styles,
    classes: ['item', (clicked.current || menuOpenedFromClick) && 'hideFocus'],
    brand: brand
  });
  return /*#__PURE__*/React.createElement("li", {
    className: classNames
  }, /*#__PURE__*/React.createElement(Button, {
    "aria-label": ariaLabel,
    "aria-controls": secondaryMenuId,
    onClick: onClick,
    onMouseDown: onMouseDown,
    onBlur: onBlur,
    buttonRef: menuItemRef,
    tabIndex: secondaryMenu ? -1 : 0
  }, /*#__PURE__*/React.createElement(Block, {
    layout: true,
    horizontal: true,
    "aria-hidden": true
  }, /*#__PURE__*/React.createElement(Block, {
    className: styles.icon
  }, /*#__PURE__*/React.createElement(ProfileIcon, null)), /*#__PURE__*/React.createElement(Block, {
    layout: true,
    flex: true,
    vertical: true,
    start: true,
    justifyCenter: true
  }, /*#__PURE__*/React.createElement(Block, {
    pl: "xs",
    className: styles.label
  }, welcomeMessage), /*#__PURE__*/React.createElement(Block, {
    layout: true,
    horizontal: true,
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(Block, {
    pl: "xs",
    pt: "xxs",
    layout: true,
    flex: true,
    className: styles.descriptionContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.description
  }, profileConfig.description), /*#__PURE__*/React.createElement(Block, {
    layout: true,
    horizontal: true,
    center: true,
    className: styles.chevron
  }, /*#__PURE__*/React.createElement(ChevronIcon, null))))))));
};

export default ProfileMenuItem;